module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NE")])]), _vm._v(" "), _c('h2', {
    staticClass: "head_1"
  }, [_vm._v("Building Defenses")]), _vm._v(" "), _c('h2', {
    staticClass: "head_2"
  }, [_vm._v(" on the Lower Mississippi River")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HE")])]), _vm._v("establishment of the Confederate States of America in February 1861 was a momentous event, and the delegates at the convention in Montgomery, Alabama, suspected their actions would likely result in war. They declared their independence and drafted a constitution, but the United States government under President James Buchannan refused to act in any meaningful way and took pains to avoid any official acknowledgment of the new government organized in Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Incoming president Abraham Lincoln was staunchly against the secessionist movement, and the provisional congress of the Confederacy took measures to establish a national defense. The framework of an army was instituted first. Shortly thereafter on February 21, 1861, a navy was established. Provisional President Jefferson Davis appointed Stephen Mallory to serve as his naval secretary.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }, [_vm._v("Mallory had many connections to the United States Navy before the war began. A native of Key West, Florida, his many political experiences would prove beneficial in the coming struggle. As a Florida Senator, Mallory served on the committee on naval affairs for a decade, learning how a navy operated and acted, as well as learning how politics blended with military matters in the higher echelons of the government. Mallory’s lasting achievement while on the committee was the establishment of a retirement board that evaluated aging naval officers to make determinations whether they should be forcibly retired. There being no provision for mandatory retirement from the navy at that time, officers gained higher rank ")]), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }, [_vm._v("and position through a seniority system that quickly swelled the senior ranks with aging and infirm officers, some of whom were in constant service for forty years or more. The new board helped make room for younger and more energetic officers.")])]), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As expected, many senior naval officers resented Mallory for his proposals while younger ambitious officers praised him for giving them the chance to both prove themselves in positions of responsibility and gain promotion, something that the new secretary would remember as the Confederate Navy was organized. Mallory’s expertise proved invaluable to the Confederacy as it struggled to maintain its tenuous hold on independence.")])]), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("Stephen Mallory, Confederate Secretary of the Navy. Library of Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With no actual naval force at his disposal, Mallory quickly went to work organizing his department and establishing an overall naval strategy. The only tangible asset was a plethora of naval officers who already resigned from the service of the United States, with more doing so each week. Ultimately 373 officers resigned or were dismissed form the United States Navy, approximately one-fourth of the service’s total. These officers were eager to serve, but in February 1861 there were no ships to assign them to and there were no major naval yards or facilities that could build or repair warships. (Norfolk, Virginia was not available until the state seceded in May.)")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }, [_vm._v("The rush of officers to Mallory’s office proved so great in early 1861 that he was directing many to join the army as artillery officers. However, things began to change as the new naval department established its policies and looked at a long-term strategy for the coming war. The Confederacy needed ships to defend its ports and Mallory looked immediately to New Orleans, Louisiana, as the best place to acquire them. This was because New Orleans was the only city in February 1861 in the new Confederacy that possessed “great workshops where machinery of the most powerful kind could be built” along the skilled craftsmen “capable of building ships in wood or iron, casting heavy guns, or making small arms.”"), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n1",
      "id": "a1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, it was also the Confederacy’s largest city and most productive port, boasting 33 steamship companies in 1860. Other civilian ports including Charleston, South Carolina, and Mobile, Alabama, with smaller privately owned repair and maintenance facilities, but nothing on the scale of New Orleans. In fact, only one naval yard at Pensacola, Florida, fell into Confederate hands before the firing on Fort Sumter, but it was rendered useless because Union soldiers held the fortifications outside the harbor, blockading the port city. In short, Mallory placed "), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }, [_vm._v("his early hopes on building a naval force in the only city he knew was capable of bringing his goals into realities."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n2",
      "id": "a2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "cen"
  }, [_vm._v("Origins of a Naval Force at New Orleans")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Funding was approved in March 1861 by the Confederate Congress for ten gunboats that were to be purchased or built and Mallory wasted no time in dispatching officials to find ships. Three officers, Captain Lawrence Rousseau, Commander Ebenezer Ferrand, and Lieutenant Robert Chapman, were dispatched to New Orleans with the task of finding civilian steamships that held promise for conversion into warships. Together, the trio of officers possessed nearly a century of combined naval experience. Rousseau was one of the most senior officers in the fledgling Confederate Navy. Having joined the United States Navy in 1809, it was believed that his fifty years of naval service would help in choosing civilian ships that held promise for potential conversion. In the midst of the secession crisis, Rousseau resigned from the United States Navy, casting his lot with the South. Commander Ferrand was equally experienced in naval affairs, having joined the United States Navy in 1823 and serving diligently until late January 1861, when he too resigned. Lieutenant Chapman, the most junior of the three, still boasted fourteen years of naval service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ship after ship was inspected by the trio, but deficiencies were found in every civilian vessel they examined. Rousseau forwarded his findings to Mallory. By the time they reached the Confederate government offices in Montgomery, Alabama, however, events intensified the situation. Confederate forces fired on Fort Sumter on the morning of April 12 and the garrison soon after surrendered. Both sides began their escalation to full-scale war. President Abraham Lincoln called for 75,000 volunteers to end the rebellion and, on April 19, declared a blockade of Southern ports. With war begun, Mallory took a closer look at the reports forwarded by Rousseau. Even with deficiencies, any ship capable must be seriously considered for use."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n3",
      "id": "a3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mallory needed to establish a naval strategy that would both protect the Confederacy and counter the Union blockade. What developed initially was a"), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_vm._v(" two-pronged approach: keep the supply lines open by circumventing the blockade, plus dispatching cruisers to sea that would wage a war against the commerce of the United States. Added to this was President Jefferson Davis’s call for privateers. In response to Lincoln’s call for troops to suppress the rebellion, Davis issued calls for issuing letters of marque and reprisal. It was hoped that privateers would benefit the weaker Confederacy, as it had done for the United States in both the War of 1812 and the Revolution against the British.")])]), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mallory realized he must acquire whatever ships could be armed to form local makeshift raiders in each major port city. Originally this force was designed with the view of breaking the Union blockade, but it evolved into a defensive fleet-in-being tasked with protecting the ports and waterways of the Confederacy until purpose-built ships constructed in Europe could be purchased and sent across the Atlantic Ocean to break Lincoln’s blockade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To execute both the offensive raiding and the defensive protection parts of his strategy, Mallory relied on Rousseau’s reports. Though the ships Rousseau found each had their own deficiencies, the Confederacy must make do with what was available. Instructions were sent to Rousseau to immediately begin purchasing ships and to commence the process of converting them for military purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another senior officer was with Mallory going over Rousseau’s findings. Raphael Semmes, known as “old beeswax” by those familiar with him because of his impeccable moustache, was a celebrated and aggressive sailor whose pre-war reputation would only grow as the conflict continued. He joined the United States Navy in 1826 and commanded the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Somers")]), _vm._v(" in the Mexican War before practicing law in Mobile. Semmes was among the first to gain a commission into the Confederate Navy in February 1861, with the rank of commander, and he was anxious to get to sea.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }, [_vm._v("Originally, Semmes was dispatched to acquire weapons from Northern states, but after Fort Sumter was captured, Semmes returned empty handed. One morning after returning, Semmes was sitting in Mallory’s office when the two began looking over Rousseau’s reports. Semmes found the report on one ship, a small merchant steamer, and turned to Mallory. “Give me that ship; I think I can make her answer the purpose.” Mallory agreed and Cmdr. Semmes left Montgomery for New Orleans to assume command of his vessel."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n4",
      "id": "a4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Rousseau initially purchased two vessels from among the list he forwarded to Mallory. Cmdr. Semmes’s vessel was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Habana")]), _vm._v(", a Caribbean merchant that transported goods between New Orleans and Cuba. Its most recent voyage took the vessel from Havana back to the Mississippi River, where it arrived on March 18, just as Rousseau’s board was commencing its work.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }, [_vm._v("Rousseau’s report noted that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Habana")]), _vm._v(" fit many requirements needed: it was a screw propelled steamer, augmented by three masts for sail-power, with a low-pressure engine capable of steaming up to ten knots. Its one major drawback was limited storage space for coal, leaving the ship with only five days of fuel for steaming. Additionally, with a draft of about 12 feet, the ship was restricted from entering many of the Confederacy’s shallow ports. Semmes believed that such deficiencies could be overcome and on April 20, 1861, Rousseau paid $65,000 (US or equivalent Confederate scrip) for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Habana")]), _vm._v(". Two days later, he ordered First Lieutenant Joseph Fry, a Virginian with twenty years of naval experience, to begin outfitting her at the Crescent dry-dock in Algiers, just across the river from New Orleans. The vessel, once in Confederate service, would be renamed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(", after the Confederate victory at Fort Sumter. Fry oversaw operations until Semmes arrived from Montgomery and took personal charge of the conversion."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n5",
      "id": "a5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cargo vessel "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marquis de la Habana")]), _vm._v(" also showed initial promise for conversion to a warship. This vessel had a colorful past. Originally built in Philadelphia in 1859, the ship was used by Admiral Thomas Marin’s naval forces siding with General Miguel Miramon’s conservative movement in the Mexican Reform War. Most notably, the vessel was involved in the battle of Anton Lizardo, where it was disabled and captured by the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saratoga")]), _vm._v(". Taken to New Orleans as a prize, the ship, along with the simultaneously captured "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Miramon")]), _vm._v(", were classified as “pirates upon the high seas.” The pair of ships were sold at auction and converted back into merchant steamers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marquis de la Habana")]), _vm._v(" made one run between New Orleans and Havana before the firing on Fort Sumter. Inspected by Rousseau and his board, the ship appeared to fit the requirements needed for a man-of-war. Powered by both a screw propeller and three masts, it was believed that the steamer might serve adequately as a raider. With a draft of 14 feet however, it was even more restricted from Confederate ports, but it was believed that such limitations were acceptable for raiding at sea. The biggest drawback was the ship’s engines, which were known to have been unreliable when the vessel was operating under Adm. Marin’s command. Nonetheless, it was believed that a good engineering department could compensate for such a deficiency. Additionally, Lt. Robert Chapman, one of Rousseau’s board members, was the officer in charge of the prize crew onboard, bringing it to New Orleans after its capture. In late April, on Chapman’s urging, Rousseau purchased the ship for $53,500. It was immediately brought to the shipyard of John Hughes in Algiers for conversion and was renamed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n6",
      "id": "a6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("First Lieutenant Thomas B. Huger, CSN.")]), _vm._v(" "), _c('p', {
    staticClass: "cen_11"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Naval History and Heritage Command")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }, [_vm._v("Mallory dispatched the best naval officers available to man and outfit these ships. Commander Raphael Semmes was given free range to select the officers that would serve with him on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(". He selected First Lieutenant John M. Kell, a Georgia native with twenty years of naval experience, including service in the Mexican War, as his executive officer. Lieutenant Robert Chapman made a request to join the crew and he was detached from Rousseau’s inspection board. First Lieutenants John M. Stribling and William E. Evans, both South Carolinians with over thirty years of naval experience between them, completed the list of Semmes’s senior officers."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n7",
      "id": "a7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To command the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(", Mallory selected 1Lt. Thomas B. Huger, another South Carolinian. Huger was a twenty-six-year veteran of the United States Navy with service off the coast of Veracruz during the Mexican War. He was the husband of Marianne Meade, sister of future Union General George Meade, who died in 1857, leaving Thomas a widower with five children. Lieutenant Huger was present at the bombardment of Fort Sumter, commanding a battery of guns on Morris Island.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }, [_vm._v("Ordered to New Orleans as Huger’s executive officer was 1Lt. Alexander F. Warley. Another South Carolinian, Warley served in the United States Navy since 1840. Like Huger, Warley was present at the bombardment of Fort Sumter, commanding batteries at the Dahlgren Channel. First Lieutenants John Eggleston and John R. Dunnington, both naval academy graduates, were likewise ordered to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n8",
      "id": "a8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" were, in Mallory’s view, envisioned as commerce raiders. They remained at sea and attacked Union shipping, making the war costlier to the United States and hopefully removing support for the war from New England merchants. Furthermore, the two ships’ presence abroad might add legitimacy to the fledgling Confederacy in the eyes of international governments. It was Mallory’s object that they serve this purpose until ships specially constructed in Europe could be acquired to expand the Confederate raiding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After purchasing the pair, Mallory dispatched a report to President Davis, updating him on activities in New Orleans. Mallory, like Rousseau, was unhappy with the tiny new navy, writing that “agents of the department have thus far purchased but two [steamers], which combine the requisite qualities. These, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(", and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(", are being fitted as cruisers and will go to sea at the earliest practicable moment.” In May 1861, the public learned of the acquisition of the two ships when newspapers printed word of their purchase and outfitting by the government."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n9",
      "id": "a9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other ships soon joined the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" in the conversion process. When Louisiana first seceded, the United States revenue cutters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robert McClelland")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington")]), _vm._v(" were seized along the New Orleans wharves. Captain John G. Breshwood, a native of Norfolk, Virginia, was in command of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Robert McClelland")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He, along with his two lieutenants, S.B. Caldwell and Thomas Fister, voluntarily surrendered the ship to Louisiana officials. All three men received appointments in the Confederate Revenue Service and were assigned back to the cutter, renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pickens")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For surrendering the ship, the men were summarily dismissed from the United States Revenue Marine, precursor to the Coast Guard, by U.S. Secretary of the Treasury John A. Dix. The revenue cutter "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington")]), _vm._v(" was likewise seized in Louisiana’s secession and turned over to the Confederacy. Limited visits by journalists and dignitaries were allowed and on one a journalist was quick to note numerous ships “which are being fitted up with great rapidity and completeness.” Revenue cutters maintained a stockpile of arms and typically held one or two cannon for defense and the pair of cutters seized in New Orleans were no exception.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pickens")]), _vm._v(" began patrolling the lower Mississippi River as part of the Confederate Navy; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington")]), _vm._v(", smaller and lightly armed with only one small cannon, was kept at New Orleans collecting revenues on incoming ships and blockade runners."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n10",
      "id": "a10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A curious addition to these improvised naval forces soon made its appearance in New Orleans. Recently captured in Texas while attempting to transport Union soldiers from isolated forts there, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star of the West")]), _vm._v(" was taken to the Crescent City as one of the Confederacy’s first prizes of war. The steamer was famous for its failed relief expedition of Fort Sumter, made in January 1861, which was repulsed by cadets from the Citadel Military Academy. Due to its nature as a passenger ship, capable of housing 1000 guests, it was purchased by Rousseau and outfitted as a receiving ship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Placed in command of the renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Philip")]), _vm._v(" was Acting Midshipman William V. Comstock, a twenty-year-old Louisiana native with four years of naval experience. Comstock was described by the press as “very gentlemanly, affable, and courteous—an ornament to the service and an honor to our glorious little Pelican State.” By May 1861, there were some 175 sailors onboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Philip")]), _vm._v(", training and working on other ships, preparing them for active service. The entire"), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }, [_vm._v(" crew of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" joined them, there being inadequate berthing space onboard Semmes’s raider for the 114 crewmen while its conversion was being undertaken."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n11",
      "id": "a11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("Birth of the Confederate Marine Corps")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the Confederate Congress created the navy department, they likewise established the Confederate States Marine Corps. The marines, just like their counterparts in the United States, were organized to man shore installations, serve as gunners and security onboard ships, repel boarders, board enemy ships, and serve as shore parties from ships. Officers were organized in Montgomery in March 1861 and Capt. A.C. Van Benthuysen, a military veteran who previously served with Garibaldi in the Italian Revolutions, was ordered to New Orleans to establish a recruitment center. Joining him was Capt. George Holmes, a Maine-born veteran of the United States Marine Corps."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n12",
      "id": "a12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("New Orleans soon expanded to become the center for marine recruiting for the entire Confederacy. By April 23, 1861, Capt. Van Benthuysen enlisted 95 marines in the New Orleans area. They were organized and designated as Company B, Confederate States Marine Corps and ordered to Pensacola, Florida, for active field service. Capt. Van Benthuysen accompanied them, but soon after returned to New Orleans to maintain recruiting efforts. These proved fruitful and by the end of May, he transferred another 150 marines to Pensacola; these were combined with Company B to form a makeshift battalion. His efforts faced competition from the army, navy, militia, and privateers for available manpower. To assist in the recruiting efforts, bounties of up to $50 were offered to potential recruits. By the end of 1861, the marines recruited in New Orleans served as the nucleus of the entire corps, with many of the noncommissioned officers promoted throughout the war being taken from the cadre of those early recruits from New Orleans."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n13",
      "id": "a13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Though most marines recruited in New Orleans were dispatched to Pensacola, many were called back to Louisiana. Both Cmdr. Raphael Semmes and 1Lt. Thomas Huger wanted marines for their ships and Secretary Mallory ordered the marines in Pensacola to dispatch detachments for each ship. First Lieutenant Becket Howell, brother-in-law to President Jefferson Davis and veteran of the United States Marine Corps, led a detachment of twenty men to report to Cmdr. Semmes to serve as the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter’s")]), _vm._v(" marine guard. First Lieutenant Richard Henderson, son of Brevet Brigadier General Archibald Henderson, the “Grand Old Man of the [U.S.] Marine Corps,” was ordered to the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" with a detachment of 24 marines. Henderson and his men reported for duty on June 17, 1861.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }, [_vm._v("These shipboard marines were often called on to fill a variety of roles. One United States marine of the time period described daily life in his diary: “one day (or rather one hour) he is a soldier—the next a sailor; and when the ship is going through the process of coaling, he may be found upon the coal whip and be denominated a coal heaver.” The detachments ordered to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" were the first Confederate marines joining a ship’s complement. Stephen Mallory and his Commandant of the Marine Corps, Colonel Lloyd J. Beall, continued their focus of recruiting efforts in southern Louisiana. It is estimated that by the end of 1861, some 80 percent of all Confederate marines were recruited in the New Orleans area."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n14",
      "id": "a14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("More Ship Inspections and Conversions")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" were being outfitted for sea, Rousseau continued his efforts inspecting vessels in search of those that could meet the requirements of naval service. On April 22, Rousseau inspected the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Florida")]), _vm._v(", a mail packet that plied the waters between Mobile and New Orleans. Despite using two paddle wheels for propulsion instead of a screw propeller, he found the vessel acceptable for coastal operations and ordered its purchase. It was outfitted on Lake Pontchartrain, just north of the Crescent City with two small boats and four artillery pieces added to prepare the ship for battle in coastal waters. The vessel’s draft of just six feet"), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_vm._v(" allowed it to operate very close to land in relative safety and to move between the many small ports in coastal Mississippi and Louisiana. First Lieutenant Charles W. Hays, an Alabamian with over twenty years of naval experience, was placed in command of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Florida")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }, [_vm._v("Additionally, Rousseau inspected the steamer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yankee")]), _vm._v(" on May 9. Built in 1849 in Cincinnati and operating since on the Mississippi River as a tug, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yankee")]), _vm._v(" was a reliable vessel that became a gunboat for protecting the Mississippi River. It already proved useful to river operations when it transported Louisiana militia to Fort Saint Philip in January after Louisiana Governor Thomas O. Moore ordered federal installations in the state seized. Renamed the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(", the ship was entrusted to 1Lt. Washington Gwathmey, an Englishman turned Virginia resident who joined the United States Navy in 1832."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n15",
      "id": "a15"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outfitting so many ships simultaneously proved more difficult than originally anticipated. There were nine dry-docks in Algiers when the war began, the largest collection being part of the shipyard owned and operated by John Hughes. Though New Orleans was a major port, the declaration of a blockade by the United States caused many foreign ships to flee the city. Additionally, many sailors were either flocking to join the army or to join a privateer. As a result, Confederate naval authorities encountered difficulties finding sailors to operate their ships. Many experienced seamen were not familiar with the requirements of men-of-war and the officers in the New Orleans area struggled to both acquire and train sailors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lack of experience proved catastrophic almost immediately. Tragedy struck the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" on May 17. A small boat under the charge of Midshipman John H. Holden, a twenty-year-old native of Tennessee, was transporting an anchor when it capsized. The swift current of the river proved too much and four men, including the young Holden, drowned. Two months later on July 20 the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" suffered a loss when recently enlisted Irishman James Keen fell off of a yardarm and fractured his skull on the wharf, dying instantly. As a result of these accidents, training was increased for all sailors in the city, with officers promoting a heightened state of safety and readiness."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n16",
      "id": "a16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Raphael Semmes initially believed that fitting out his ship would be relatively easy. Reality proved otherwise as he struggled for months to prepare the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" for"), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_vm._v(" sea. Besides finding a crew, Semmes had to alter the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" into a cannon armed raider.")])]), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Semmes recalled the first time he set eyes on the ship after arriving in New Orleans on the morning of April 22. Though the passenger liner would need plenty of work, Semmes found himself pleased with the ship. “Her lines were very easy, and graceful,” he later recalled, “and she had a sort of saucy air about her.” Within ten days the ship was sent to the Crescent dry-dock in Algiers and shipyard workers began the process of removing the upper cabins, strengthening the decks to support heavy cannon, refurbishing and adding new sails and rigging, installing a new main mast, and contracting for the required supplies needed to keep a ship at sea for an extended period of time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }, [_vm._v("Though New Orleans had several shipyards, they were not accustomed to outfitting men-of-war. Additionally, since the city lacked an organized naval station, naval agents scoured for supplies like competitive companies bidding for a contract, resulting in several instances where one ship would place bids for supplies against another. “Everything had to be improvised, from the manufacture of a water-tank, to the ‘kids and cans’ of the berth-deck messes, and from a gun-carriage to a friction-primer.” Semmes’s executive officer, Lt. John Kell surmised that such improvisations “consumed much more time than we anticipated.."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n17",
      "id": "a17"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most important were the cannon that would change a vessel into a warship. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" was redesigned to be armed with five cannon, four 32-pounders in broadside and one 8-inch gun on a pivot amidships. The 8-inch gun was sent from the defenses of Charleston, but the remainder of the guns needed to be found elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately for the Confederacy, Virginia, North Carolina, Tennessee, and Arkansas seceded after President Lincoln called for volunteers to suppress the Confederate rebellion. With the secession of Virginia came the Gosport Navy Yard in Norfolk, the best naval installation in the South. It possessed hundreds of cannon, a large dry-dock, and warehouses full of supplies that Mallory’s department desperately needed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Semmes placed a request for cannon and four 32-pounders were dispatched from Virginia. Delays continued, however, due to the not always reliable rail transportation network. When the cannon finally arrived, they lacked carriages and Semmes contracted with the firm of John Roy, who was also constructing gun carriages for the army, to meet his needs. After the guns were finally installed, Semmes next turned to gunpowder. Secessionists captured the United States military arsenal at Baton Rouge, Louisiana, intact in January 1861. Over 300 barrels of powder were seized and a portion was dispatched downriver."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n18",
      "id": "a18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae. Naval History and Heritage Command and Photographic History of the Civil War")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preparations on the "), _c('span', {
    staticClass: "bi"
  }, [_vm._v("McRae")]), _vm._v(" were just as tedious. Lieutenant Huger’s ship was considered the most formidable of Rousseau’s original pair, but it faced many of the same challenges the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" did. The hull was painted black to make the ship seem more imposing and it would be more heavily armed; six 32-pounders from the Gosport Navy Yard in Norfolk were dispatched for the vessel. One 9-inch Dahlgren gun and one 24-pounder brass rifle, both mounted on pivots so they could be rotated and fired from either side of the ship, were also added to the vessel’s armament. The Dahlgren gun was reinforced with two wrought-iron bands, allowing greater charges of powder to be used for added range and force.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }, [_vm._v("Huger and his executive officer, Lt. Alexander Warley, worked tirelessly to organize a crew and get to sea. By June, some 120 officers and men joined the ship’s complement. “You must not be surprised to hear of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" taking prizes,” one sailor wrote home, pointing out the eagerness of the crew to reach the open ocean")]), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }, [_vm._v(" and get to work. The greatest struggle for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" was preparing the engines, boilers, and six furnaces for sustained use. The chronic engine problems that plagued the vessel off the coast of Mexico the previous year remained and extra engineers were assigned to the ship to ensure it would be ready for a sustained cruise."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n19",
      "id": "a19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The citizens of Louisiana were proud of the ongoing work at the wharves of New Orleans and Algiers. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" “is an excellent sea-boat, and is being thoroughly overhauled and strengthened in every part,” printed one newspaper, “and will doubtless, under the command of her very efficient officers prove a no mean acquisition to our little navy.” Furthermore, the shipyard workers of the city toiled to finish preparing the ships for service. Onboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(", “as many workmen as could be employed were cutting away the light passenger cabins, strengthening decks for supporting the battery."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n20",
      "id": "a20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("Mallory’s Plans for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides the senior officers commanding the ships, few knew how Mallory intended to employ the vessels being outfitted in New Orleans. A lack of knowledge did not halt speculation and rumors ranged from steaming on the open ocean to attacking up the Mississippi River. One Union newspaper editorialized that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" would be dispatched to Memphis. These thoughts echoed General Gideon Pillow, commanding troops in Tennessee, who wrote to the Confederate secretary of war, demanding that “if the President has not yet ordered the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" up, let it be done as promptly as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crewmembers were unaware of where their ships were destined, though they too joined in the speculation. John H. Dent, an engineer onboard the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(", ventured a logical guess to his father: “I can’t imagine where we will go but I suppose we will try and sink the blockade.."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n21",
      "id": "a21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mallory wanted the armed tug "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(" to defend the lower Mississippi while the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" went to sea as raiders. Just as the two others, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(" was armed as quickly as possible. Conversions were underway for the smaller vessel to mount two 32-pounders and special gun carriages reinforced by a rail iron chassis were fabricated to add stability to the cannon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, Semmes and Huger knew their deployments entailed facing Union blockading ships; Lt. Warley of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" boasted to a fellow officer that “we would sink all of Lincoln’s ships by fire if we could not take them into port.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }, [_vm._v("The United States Navy did not sit idly by while the Confederacy organized its new naval forces. In May, the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn")]), _vm._v(" started the blockade of the Mississippi River and began patrols at its entrances from the Gulf of Mexico, bringing the war to the New Orleans area firsthand."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n22",
      "id": "a22"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" was the first ship completed and deemed ready for service. Raphael Semmes hoisted the Confederate flag on June 1, 1861, and conducted several days of trials before bringing the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" downriver in preparation to run the blockade. Semmes admitted to Stephen Mallory that his crew was “nearly all green,” and still in need of extensive training, but he did not want to remain in Louisiana waters any longer."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n23",
      "id": "a23"
    }
  }, [_vm._v("23")])]), _vm._v(" On June 30, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" made a daring escape from the Head of the Passes, humiliating the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn")]), _vm._v(" in the process. Commander Semmes was the first naval officer to fly the new Confederate flag at sea, leaving New Orleans behind for the remainder of the war. In the next seven months of cruising, he would capture 18 merchants and steam from the Caribbean to Europe. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" was commissioned in July, but developed engine problems on its initial trials. Further complications developed while steaming to Baton Rouge to receive ammunition and powder. One engineer commented in a letter home that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" “had the misfortune to break or crack two of the wheels which drives the propeller shaft.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n24",
      "id": "a24"
    }
  }, [_vm._v("24")])]), _vm._v(" Several weeks were needed to complete a repair, time that neither Lt. Huger nor Secretary Mallory wanted to waste.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" was intended to raid on the open ocean, the same was not true of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(". With commerce raiding as its cover, Mallory intended to send the vessel to England on a secret mission. Lieutenant Huger received sensitive dispatches that he was to deliver to Confederate agents in London. In them were instructions to purchase 10,000 rifles, 200 tons of gunpowder, and anything else of"), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }, [_vm._v(" value that could be crammed onto the ship. Once loaded, Huger was ordered to steam the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" back to the Confederacy, protecting a convoy of merchant ships that were supposed to be organized in England, and attack any enemy merchant ships encountered on the journey.")])]), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }, [_vm._v("To prepare for such work, extra speaking trumpets and a plethora of hand and leg irons were supplied to keep potential prisoners locked up, a new set of sails was furnished to help give chase (or escape) on ocean voyages, and wrought iron bulwarks were constructed to protect the engine and boiler rooms from enemy shells. Commerce raiding was very appealing to the officers. One boasted that “all that our officers wish is to capture and burn every thing that we cannot take.."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n25",
      "id": "a25"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The secret plan did not transpire. On the trials following the repairs to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae’s")]), _vm._v(" propeller shaft, more problems developed when “lugs in the driving wheels tore out.” The ship turned back upriver for yet more repairs. By the time these were completed, the Union blockade tightened and Huger’s secret mission was cancelled. Instead, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" was reclassified as a river gunboat to augment the tug CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(", still being refitted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Conversion of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(" went more smoothly; many of the city’s contractors learned valuable lessons outfitting the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(". With Lt. Huger protecting the southern portions of the Mississippi River with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" and augmented by the revenue cutters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pickens")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Washington")]), _vm._v(", it was deemed necessary to do the same further upriver and once completed, Lieutenant Gwathmey brought the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jackson")]), _vm._v(" north to Tennessee, arriving in late August.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saint Philip")]), _vm._v(" remained at New Orleans as a receiving ship. A small hospital was added to the ship so that naval personnel could be cared for onboard. By the end of the summer of 1861, the Confederate Navy had working ships in New Orleans. With no government shipyard, no supplies, and little money, Mallory’s officers acquired several vessels and prepared them for battle, albeit improvised. Confederate naval aspirations were to test the blockade of the Mississippi River, and attempt to clear the Gulf of Mexico of Union ships."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n26",
      "id": "a26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }, [_c('p', {
    staticClass: "cen_1"
  }, [_vm._v("The New Orleans Privateers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Confederate Navy was not the only organization working along the wharves of New Orleans. After the bombardment and surrender of Fort Sumter, President Abraham Lincoln declared a blockade of ports in Texas, Louisiana, Mississippi, Alabama, Florida, Georgia, and South Carolina. After the secession of North Carolina and Virginia, the blockade was extended to include those states as well.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-34"
    }
  }, [_vm._v("Jefferson Davis, in response, issued a call for privateers through letters of marque and reprisal. Davis’s move was a traditional one for smaller powers when facing larger foes. The United States made the same decision in the American Revolution and the War of 1812 against Great Britain. Recently, however, Europeans sought to eliminate the practice of privateers. Representatives gathered in Paris in 1856 and issued a declaration that made the use of privateers illegal to the signatories. The Declaration of Paris would not affect the coming conflict in America. This was because the United States initially refused to sign the declaration and the European powers would not let them try to do so as to benefit after the fact. Foreign powers did attempt to pressure both sides into respecting the declaration and Secretary of the Navy Stephen Mallory agreed that the Confederacy would “hold ourselves responsible to for[eign] governments for the tortuous conduct of our privateers."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n27",
      "id": "a27"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the wealthy and elite in New Orleans answered Davis’s call for privateers. There was money to be made, after all. A privateer, after receiving its letter of marque and reprisal, was allowed to attack enemy ships, both merchant and men-of-war. Each ship captured by a privateer was subject to condemnation by a prize court. After that, captured ships and cargo were available for sale to the highest bidder. The profits would then be split between the privateer’s financial backers and crew. Additional prize money was offered by the Confederate government for those that were willing to attack and capture a Union gunboat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though the potential for prize money was enticing, it was split between many different authorities. Backlogs in the judicial system caused both court and port fees to quickly accrue. Auction fees would also be paid after a ship’s capture was approved by the admiralty court. Only after the auction was complete and all fees"), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }, [_vm._v(" were paid was prize money distributed. In theory, this distribution was divided evenly between the owners of the vessel and the crew. Often, there were many owners backing finances of a ship. One New Orleans privateer, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(", was owned in part by eight backers split in eleven parts, and prize money first went to them before sailors saw anything for their efforts. Against potential profit was the cost of supplying and operating a vessel at sea. For many sailors the lure of prize money resulted in little or nothing."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n28",
      "id": "a28"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The call for privateers spread across the Confederacy’s major ports. New Orleans quickly bustled with activity as prominent citizens worked to organize and prepare privateers for sea. Advertisements were placed in local newspapers calling for adventurous and industrious seamen to join with the promise of a share of any prize money earned in captures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first privateer to gain notoriety was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(". She was formerly the steamer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cuba")]), _vm._v(", New York built and operating on the river since 1851. Her captain, John Wilson, recruited 150 citizens of New Orleans and procured five small cannon—more akin to army field artillery than naval guns—to arm his small 500 ton vessel: a pair of six-pounders, one 18-pounder, and two 23-pounders. The weapons would not be able to compete against a Union warship but was enough to force unarmed merchants to submit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun’s")]), _vm._v(" letter of marque was approved on May 15, 1861, just five weeks after President Davis issued his call for privateers, and Capt. Wilson wasted no time in proceeding to sea. The very next day, it captured the first Union merchant ship taken in the war, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean Eagle")]), _vm._v(". Captain Wilson sent it upriver with a small prize crew and the assistance of a nearby towboat while he patrolled the mouth of the Mississippi River. Two days later Wilson’s crew struck again, capturing the schooner "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ella")]), _vm._v(" and the merchant ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milan")]), _vm._v(". Crowds lined the riverbank of New Orleans as Wilson took the two captures in tow upriver for adjudication.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(" was just getting started. After a few days resupplying in New Orleans, Capt. Wilson again got underway for the Gulf of Mexico. He shortly caught three New England whalers, the schooners "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Adams")]), _vm._v(", in the charge of Master C.B. Averall, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mermaid")]), _vm._v(", commanded by a man named Soper, along with the brig "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Panama")]), _vm._v(", in the care of Master Powell, about 90 miles out from the entrance to the Mississippi River. Captured on the same day, the three whalers were transporting 215 barrels of valuable whale oil. Taking his three prizes, Wilson steamed back up the Mississippi River for New Orleans. Fortunately for the privateers, they did so just in time, as the Union gunboat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn")]), _vm._v(" arrived in view and missed intercepting the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(" by mere hours. The Union gunboat then began the official blockade of the Mississippi River."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n29",
      "id": "a29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("The privateer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "cen_11"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Naval History and Heritage Command and Erik Heyl, Early American Steamers, Vol. 3.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-36"
    }
  }, [_vm._v("The six captured ships were brought before the New Orleans district court for adjudication. The Confederacy, just like the United States, declared that district courts would serve as admiralty courts regarding captured prizes. The judge spent two months reviewing Capt. Wilson’s cases before ruling that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun’s")]), _vm._v(" six captures were legitimate. The prizes and their contents were placed at auction and sold on July 27, 1861. At times, cargo was just as valuable in auctions as the ships themselves and some 1,500 sacks of salt that were onboard the captured "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Milan")]), _vm._v(" were sold at $1.56 per sack. The whale oil was also sold at a handsome price, with final bidding at the auction bringing $30,400 for Wilson, his benefactors, and his crew, a handsome profit indeed."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n30",
      "id": "a30"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the admiralty court was deciding the fate of the captured six ships, another judge was reviewing a more immediate concern brought forth by their capture. Among the 63 crewmen captured on the three whaling vessels were eight free Negro sailors. It was not uncommon for runaway slaves to escape and sign onto whaling vessels, where they typically remained safely out of reach of bounty hunters. Upon first sighting the freedmen, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun’s")]), _vm._v(" crew presumed they were"), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }, [_vm._v(" indeed escaped slaves and they were immediately locked away in the New Orleans police station until their status could be clarified. Messages were dispatched to Judah Benjamin, then the Confederacy’s attorney general, for instructions but he stated that such a matter as to their fate should be dealt with at the level of the Louisiana court system.")])]), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }, [_vm._v("For fear of disrupting potential future prisoner exchanges, the courts did nothing and the eight remained locked up for over a month. It was only after the Confederacy passed national regulations for dealing with captured civilian sailors from the United States that they were finally released, to the disappointment of many in Louisiana and to the surprise of the sailors themselves, who believed their destiny was the slave auction block."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n31",
      "id": "a31"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(" was just the first privateer operating out of New Orleans. As Capt. Wilson took his ship into the gulf for its initial voyage, another privateer was also searching for Union merchant ships. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music")]), _vm._v(", owned and captained by Thomas McLellan, received its letter of marque on the same day as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(". A smaller vessel that displaced only 273 tons, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music")]), _vm._v(" mustered a crew of 100 sailors and volunteers to man its pair of six-pounders. Entering the Gulf of Mexico, McLellan overhauled and seized the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John H. Jarvis")]), _vm._v("—full of salt—on the same day that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(" seized the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ocean Eagle")]), _vm._v(", doing so “in the name of Jefferson Davis."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n32",
      "id": "a32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, McLellan teamed up with another privateer for yet another capture. A well-known river towboat, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy")]), _vm._v(" was under the charge of N.B. Baker. His letter of marque was dated May 16, and he rushed to crew his small steamer. It soon reached its complement of 60 men to help man its single 15-pounder cannon and steamed downriver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Being a towboat, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy")]), _vm._v(" was not easily distinguishable as a privateer and Baker planned on using this to his advantage. Baker and McLellan devised a plan to trick a passing Union merchant they sighted on the horizon. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy")]), _vm._v(" approached the merchant, which proved to be the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marshall")]), _vm._v(", and offered to provide its services as a towboat. The captain of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marshall")]), _vm._v(" agreed and his ship was towed up the Mississippi River. From there, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music")]), _vm._v(" appeared and its men boarded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marshall")]), _vm._v(", which was easily overwhelmed and brought to New Orleans. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John H. Jarvis")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marshall")]), _vm._v(" were brought before the admiralty court, condemned, and sold at auction for a combined $50,000. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy’s")]), _vm._v(" career as a privateer was not over; she later"), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_vm._v(" captured the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enoch Train")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sarah E. Pettigrew")]), _vm._v(", before being used as a scout ship at the Head of the Passes for the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sumter")]), _vm._v(" a short while later.")])]), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Other ships applied for letters of marque from New Orleans, but failed to accomplish anything noteworthy. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("W. H. Webb")]), _vm._v(" received its privateer commission in May 1861, but acted only as a troop transport on the river through 1861 and into 1862; her captain, Joseph Leach, never got the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Webb")]), _vm._v(" into the open waters of the Gulf of Mexico. The J"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".O. Nixon")]), _vm._v(" was outfitted by Capt. Wilson of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(" in July 1861 but made no captures. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mocking Bird")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Matilda")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isabella")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Governor A. Mouton")]), _vm._v(", all received letters of marque in June 1861, but none ever got to sea, with owners either running out of money while outfitting or abandoning the projects due to the tightening blockade of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most interesting venture put forth by privateer backers involved the small tug "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enoch Train")]), _vm._v(". Not to be confused with one of the prizes of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy")]), _vm._v(" sharing the same name, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enoch Train")]), _vm._v(" was a tug in New Orleans at the outbreak of hostilities. Captain John Stevenson converted her into an ironclad ram, intending to steam down the Mississippi River against Union warships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the ship was completed, it was seized by the Confederate Navy, prematurely ending its privateer career. Like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Enoch Train")]), _vm._v(", three other privateers—the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calhoun")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ivy")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Music")]), _vm._v("—were eventually purchased by and incorporated into the Confederate Navy to augment river defenses. The only other privateer of note in the New Orleans area was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pioneer")]), _vm._v(", a submarine built in Bayou Saint John and operated on Lake Pontchartrain. It reportedly sank a test target and received a privateer’s commission but was never used in battle. The engineers behind creating the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pioneer")]), _vm._v(" relocated to Mobile and later Charleston where they continued to build submarines, including the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("H.L. Hunley")]), _vm._v(", the first submarine to sink an enemy ship in battle.")]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("New Orleans Becomes a Military City")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-38"
    }
  }, [_vm._v("In addition to the ongoing naval preparations, southern Louisiana hummed with army-related activity as Major General David Twiggs worked to build and strengthen existing fortifications and train soldiers. The entrance to the Mississippi River was first fortified by the Spanish in 1746. Spanish and British forces clashed there during the American Revolution and the United States defended the area from British incursion during the War of 1812. The United States built another fort there in 1822-1823 named after 1812 war hero Andrew Jackson. Twiggs strengthened Forts Jackson and Saint Philip, located 75 miles downriver from New Orleans at a strategically located turn in the river. Fort Saint Philip was built by the")]), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }, [_vm._v(" Spanish and used by the Americans to defeat a British fleet in 1814. Since then, well over $200,000 was spent modernizing and maintaining the old Spanish fort, now mounting fifty-two cannon. After the War of 1812, Fort Jackson, larger and mounting nearly one hundred cannon, was constructed on the opposite side of the river at a cost of nearly one million dollars. Any Union ships advancing up the river must pass directly under the guns of these two fortifications."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n33",
      "id": "a33"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Besides these two main forts, there were three smaller secondary positions that protected the approaches of southern Louisiana. Fort Pike, mounting 41 cannon, was designed to protect Lake Borgne and its approaches to New Orleans from the east. 10 miles northeast from there, Fort Macomb’s guns protected other approaches to New Orleans via Lake Borgne and Lake Pontchartrain. Fort Livingston was constructed to protect the approaches through Barataria Bay to the southwest of the city. These old United States fortifications were strengthened by General Twiggs, who also began work on an interior set of fortifications designed to serve as a last defense of New Orleans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately downriver from the city was the Chalmette Battery, augmented by the McGehee Battery on the western bank of the river. The Chalmette Battery was located on the site of General Andrew Jackson’s victory over British forces in 1815 and mounted 10 guns. The McGehee Battery was lightly armed and supported the position at Chalmette. Upriver from New Orleans was Fort John Morgan. This line of breastworks was designed to hold back a Union land attack coming from the north and west, with a few guns aimed at the river to stop approaching ships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the fortifications, there were several training camps erected in and around the city. Camp Benjamin, named to honor Louisiana resident and Confederate cabinet member Judah P. Benjamin, was north of the city on the Pontchartrain Railroad. The Metairie horse racecourse was converted into a training camp for new recruits. Camp Lewis was erected to train militia on the site of present-day Audubon Park. These camps augmented the Jackson Barracks, continuously housing soldiers in the New Orleans area since the War of 1812."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n34",
      "id": "a34"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Twiggs recruited men for the defense of southern Louisiana and New Orleans, being the Confederacy’s most populous city, was called upon to supply a large proportion of the volunteers. The state militia was strengthened and by the end of "), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_vm._v("1861 numbered 26,000 men, 15,000 of whom were garrisoned or drilling in the New Orleans area. Many volunteer regiments also formed for service in the Confederacy’s provisional army. By the spring of 1862, the greater New Orleans area was protected by eleven infantry regiments, five infantry battalions, one heavy artillery regiment, and seven batteries of artillery, all of which mustered for three years of service. This force of some 10,000 trained volunteers formed the backbone of army defenses for New Orleans. When combined with the local militia, there were, theoretically, some 25,000 soldiers prepared to defend the city.")])]), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Confederate Regular Army also used New Orleans as a recruitment pool. One infantry company and one artillery battery of regular soldiers enlisted in New Orleans in 1861 and added to the city’s defenses. Besides this, at least 10 other Louisiana state regiments were organized and trained in the New Orleans area before being dispatched north, where they were serving in Kentucky and Virginia along the Confederacy’s northern borders.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }, [_vm._v("In early October 1861, General Twiggs grew ill and was relieved at his own request. Following a lengthy debate, Twiggs’s immediate subordinate was tapped to fill the replacement. That man was Major General Mansfield Lovell. Questions over his qualifications were focused on his loyalties. Lovell was considered a northerner, a native of Washington D.C. who graduated from West Point and served in the Mexican War. His family had a robust military history and his father served as the first surgeon general of the United States Army. Lovell left the U.S. Army in 1854, helping to organize John Quitman’s filibuster expedition to Cuba before working in New York City until the war began. He ignored the skepticism and doubts of his loyalty and brought a professional attitude to New Orleans, working tirelessly to strengthen its defenses, with a belief in a unity of command."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n35",
      "id": "a35"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upon assuming command, Lovell made a tour of all fortifications, determined to improve them. He dispatched ordnance officers to Virginia and Florida to find newer cannon for the forts. Lovell also placed log obstructions on the Mississippi River both above and below the city. The logs were anchored in the river by heavy chains, positioned between Fort Jackson and Fort Saint Philip. They were deemed quite formidable “because of the swift current down and the slowness of the ships below, which together, would prevent [Union ships] from striking it a blow of sufficient power to break through.” A small gap, directly under the guns of the nearby forts, was left to allow Confederate ships to pass. Another log barrier was constructed upriver from New Orleans at Fort John Morgan. More log barriers were proposed further upriver to protect Memphis using floating batteries and rafts anchored in place, but a lack of available supplies and funding forced their abandonment in the planning stages."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n36",
      "id": "a36"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/9.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }, [_vm._v("Unfortunately, a buildup of river mud and a swift current threatened to destroy his main barrier at Forts Jackson and Saint Philip. Lovell sent for his brother, William S. Lovell, to provide a close inspection of the barrier. The younger brother was a graduate of the United States Naval Academy who made numerous cruises off of Africa, South America, and the Arctic before resigning his commission in 1858 and becoming a cotton planter in Mississippi. William also held a connection to the Quitman family, having married the daughter of John Quitman. With his naval experience combined with the loyalty of being the commanding general’s brother, William, who was at the moment in Pensacola in charge of its harbor police force, was a good candidate to both provide a detailed inspection of the log barrier and ensure things were handled to the general’s satisfaction."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n37",
      "id": "a37"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The younger Lovell, a major of artillery, made a survey of the barrier and found it lacking and “very much broken up.” He quickly determined to recreate the barrier, this time using ships instead of logs. Lovell commandeered old schooners that were “anchored across the river, in line abreast, between the forts, and chains and lines were passed from vessel to vessel.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n38",
      "id": "a38"
    }
  }, [_vm._v("38")])]), _vm._v(" The use of old ships instead of wooden logs made the obstruction more formidable in preventing Union ships from passing. The elder brother was pleased with William Lovell’s work and saw to his army promotion as a lieutenant colonel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The city of New Orleans was also becoming a center of military production. By the summer of 1861, “a laboratory was established in New Orleans, and authority given for the casting of heavy cannon, construction of gun carriages, and the manufacture of projectiles and ordnance equipments of all kinds.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n39",
      "id": "a39"
    }
  }, [_vm._v("39")])]), _vm._v(" Three powder works were also created in the city and by early 1862 New Orleans was producing over 5,000 pounds of gunpowder daily.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Additionally, an old hospital was commandeered by the army, with half being used to treat sick soldiers and the remainder being converted, apparently without much thought, into an ammunition factory. Four major iron works and foundries in the city were converted for manufacturing guns and naval supplies. The Southern Shoe Factory hired more workers and was soon making 250 pairs of boots daily. Though the blockade caused a considerable downturn in the city’s economy, New Orleans’ industry remained busy to meet the needs of the Confederate military.")]), _vm._v(" "), _c('p', {
    staticClass: "cen_1"
  }, [_vm._v("Cooperation at Ship Island")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The buildup of military infrastructure made New Orleans an even more crucial target for Union ambitions. Recognizing this, the city’s civilian and military leadership worked diligently to bolster the defenses of the lower Mississippi River and prevent Union incursions at its mouth and in the many lakes and bayous that covered southern Louisiana. In 1861, the largest and most coordinated of these defensive activities was the Confederate occupation and fortification of Ship Island, strategically located off the coast of Mississippi. The operation materialized in the summer after Union blockading ships began dispatching steam launches into the sounds and inlets of coastal Louisiana and Mississippi. Lawrence Rousseau and General David Twiggs both saw these small incursions as a serious threat and formed an expedition to take care of the situation. They turned to 1Lt. Alexander Warley, a former lieutenant in the United States Navy who resigned on Christmas Eve in 1860 after his native state of South Carolina seceded. After participating in the capture of Fort Sumter, he was ordered to New Orleans as the executive officer of the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(", which was still undergoing final preparations for sea in early July. Warley was approached by Capt. Edward Higgins, an old friend and former naval officer who was then serving in the 1st Louisiana Heavy Artillery Regiment. It was he who proposed to David Twiggs the clearing the Mississippi Sound of Union launches and occupation of Ship Island. At first Warley was reluctant to assist; Lt. Thomas Huger, his commanding officer, was out of town on business and he did not want to act without permission. Higgins insisted that the men would only be needed for two days and Warley finally acquiesced, gathering a large part of the crew from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" and augmenting them with some recently arrived marines from Pensacola. The force of some 80 sailors and 55 marines boarded two steamers, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("J.D. Swain")]), _vm._v(", in Lake Pontchartrain just north of New Orleans and they charted a course for the Mississippi coast."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n40",
      "id": "a40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }, [_vm._v("The two ships departed Lake Pontchartrain on July 5, 1861 for Bay Saint Louis, a small coastal Mississippi town. Arriving there, the sailors spent the rest of the day loading their two steamers with sandbags and cotton bales to offer protection against rifle and artillery fire. Departing at 9:00 am the next morning, they began the search for Union launches. No enemy craft were sighted on the horizon and after a day of fruitless searching, Higgins proposed landing on Ship Island and fortifying the position. Warley eagerly responded that he “was in for it” and a landing was made at 4:00 pm on the afternoon of July 6."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n41",
      "id": "a41"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Being the only safe deep-water anchorage between New Orleans and Mobile, Ship Island was strategically located as the best staging and supply point for Union forces in the eastern Gulf of Mexico. Higgins wanted to fortify the island to prevent the Union Navy from using the island as a staging point for an invasion up the Mississippi River. Aware of its strategic value, the United States began work on a permanent fort there in 1857, work that remained incomplete during the secession crisis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After their initial landing, Warley’s men unloaded sandbags and cannon and dug earthworks to withstand an enemy attack. The group brought one 32-pounder cannon, one eight-inch cannon, and two howitzers from New Orleans. A lookout was placed in the lighthouse to keep watch on the horizon. This was fortunate, for two ships were quickly sighted. They proved to be small fishing boats and after an inspection by the crew of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(", the fishermen were released. Work continued into the evening, but Warley’s contingent was not prepared to provide a permanent garrison because most of the sailors and marines were crewmembers of the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v(" loaned to the army. As his sailors constructed fortifications, Warley dispatched Capt. Higgins and the two ships back to New Orleans with requests for replacements to garrison the island."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n42",
      "id": "a42"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For three days, the sailors fortified Ship Island. Warley split the artillery, placing two guns in the still incomplete fort and two in sand earthworks on the beach. The biggest worry was the limited supply of available powder and shells. Taking a small towboat, Midn. Sardine Stone travelled back to Bay Saint Louis to plead with local army commanders. They responded with the requested supplies, as well as additional manpower. A militia detachment of 75 men returned with Stone as an immediate reinforcement, bringing the total number of personnel on the island to just over 200.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }, [_vm._v("On the evening of July 8, the lookout in Ship Island’s lighthouse spotted a Union gunboat on the horizon. The enemy ship, which proved to be the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" under the command of Cdr. Melancton Smith, closed and anchored within a mile of Warley’s guns for the night. At dawn, Warley ordered Midn. Charles W. Read to open fire on the Union ship with the 8-inch cannon, doing so while the officers of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" were gathered for breakfast."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n43",
      "id": "a43"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Commander Smith ordered his guns manned and surveyed the Confederate positions, looking through his glass, finding “3 secession flags, 39 tents, and 4 batteries in process of erection, the materials used in construction being bales of cotton and sand bags.” The artillery exchange was short and, after about an hour, Smith withdrew the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" out of range, with only minor damage “cutting up the rigging somewhat.” Overall, Warley’s men fired some 26 shots while Smith’s gunners replied with seventeen “which sank in the sand” ineffectually."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n44",
      "id": "a44"
    }
  }, [_vm._v("44")])]), _vm._v(" There was only one casualty in the exchange, a Confederate who suffered a slight leg injury. While Warley’s men exchanged shots with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(", Capt. Higgins was collecting reinforcements. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("J.D. Swain")]), _vm._v(" arrived in New Orleans on the morning of July.7 and Higgins secured the cooperation of Lieutenant Colonel Henry W. Allen, a Louisiana lawyer and politician, with a contingent of 400 men from the 4th Louisiana Infantry Regiment. A day later, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and the steamer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gray Cloud")]), _vm._v(" were loaded with men, ammunition, and supplies and departed for Ship Island, arriving several hours after the exchange of cannon fire. They docked and immediately began to offload men and supplies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Allen’s men were disembarking, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" again appeared with “the intention of shelling the working party.” Warley’s sailors opened fire once again and the ship withdrew after replying with one symbolic shell in defiance. The Confederates completed offloading reinforcements and Lt. Col. Allen relieved Warley as commander of Ship Island that evening. Warley and his men, with the exception of one midshipman who remained behind as a temporary advisor, boarded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and the “tired and sandy crowd turned cityward [sic]” to finish outfitting the CSS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McRae")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n45",
      "id": "a45"
    }
  }, [_vm._v("45")])]), _vm._v(" Higgins praised Warley and his sailors in his"), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }, [_vm._v(" after-action report, noting this first instance of Confederate joint military operations, even if largely improvised, as a great success.")])]), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }, [_vm._v("Four days after Lieutenant Colonel Allen assumed command, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" made another appearance, this time anchoring about three miles from Ship Island. Allen wanted to entice Cmdr. Smith into a trap. As Smith noted in a report to his superior, “the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arrow")]), _vm._v(", were discovered under full steam, heading for this vessel.”"), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n46",
      "id": "a46"
    }
  }, [_vm._v("46")]), _vm._v(" Allen tried to use the two ships as bait to lure the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" into the range of his land batteries. The ploy did not work and Smith opened fire on the two Confederate ships with his long-range guns. As they retreated, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" did not pursue. Lieutenant Colonel Allen’s plan failed and this second engagement between Cmdr. Smith and the defenders of the island ended with no damage on either side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in New Orleans, General Twiggs recognized that armed gunboats were needed to support Ship Island, lest the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(" and other Union ships harass and assault the island at their leisure. He wrote to the secretary of war in early August requesting “a force of efficient gun-boats to co-operate with the Ship Island fort. I would respectfully recommend that such a force be stationed in Mississippi Sound with the least possible delay.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n47",
      "id": "a47"
    }
  }, [_vm._v("47")])]), _vm._v(" A small force of gunboats was indeed ordered constructed in New Orleans specifically for service in this coastal region, but it would be months before they were ready. The best that could be offered immediately was the promise of more reinforcements to garrison the island. By the end of August, Lt. Col. Allen had four companies of the 4th Louisiana Infantry Regiment, two companies of the Confederate Regular Army, and one independent company called the Washington Light Infantry manning 13 heavy guns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early September, 1861, Col. Johnson Duncan, commanding officer of the 1st Louisiana Heavy Artillery, was ordered to assume command of Ship Island and conduct a survey of its defense. Duncan was not impressed. “The fort on Ship Island,” he concluded, “is wholly incapable of resisting a combined land and water attack like that which the enemy threatens.” Duncan further claimed that “however much they may be strengthened, they can still be starved into submission without firing a single shot,” concluding “the occupation of the island is objectless.” Major "), _c('a', {
    attrs: {
      "id": "VPS-47"
    }
  }, [_vm._v("Martin L. Smith, who accompanied Duncan in his survey, wanted to maintain the position, but noted that if the island were to be evacuated, “the proper defense of the sound is a question to be taken in connection with the gunboat force that is or will be available."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n48",
      "id": "a48"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Senior officials did not wait long to analyze Duncan’s and Smith’s reports and on September 13, Maj. Gen. Twiggs ordered the island evacuated. (Twiggs resigned the next month due to health concerns.) Colonel Duncan disabled the lighthouse and began evacuating the garrison, reporting “all the guns, carriages, equipments, implements, &c., ammunition, commissary, and quartermaster’s stores, engineer’s tools, and all other public and private property” taken off the island by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oregon")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n49",
      "id": "a49"
    }
  }, [_vm._v(".49")])]), _vm._v(" The evacuation was completed on the morning of September 16, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Union forces wasted no time and quickly occupied the island. The same day that the Confederates left, Cmdr. Melancton Smith ordered the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Massachusetts")]), _vm._v(", accompanied by the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Preble")]), _vm._v(" and the USS "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marion")]), _vm._v(", to land parties on the island. The landing force took possession of “thirteen shanties and building still standing, a large quantity of lumber, some iron, and 36 head of cattle.” Commander Smith also found a note from Lt. Col. Allen addressed to him offering “our best wish for your health and happiness” but assuring Smith that “before the war closes . . . we may meet face to face in closer quarters."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#n50",
      "id": "a50"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colonel Duncan argued that the island should be abandoned and gunboats instead used to defend Mississippi Sound. However, no such a force yet existed. By the time Confederate gunboats were available for use, they were insufficient to contest control of the coastline of Mississippi and Louisiana or challenge Union control of Ship Island. By the end of 1861, the island became a staging area for the invasion of southern Louisiana with thousands of Union soldiers massed there for a planned assault up the Mississippi River to capture New Orleans.")]), _vm._v(" "), _c('div', {
    staticClass: "note_1"
  }, [_c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a1",
      "id": "n1"
    }
  }, [_vm._v("1.")]), _vm._v("  Charles W. Read, “Reminiscences of the Confederate Navy,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Southern Historical Society Papers")]), _vm._v(" 52 vols. (1876), 1:331.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a2",
      "id": "n2"
    }
  }, [_vm._v("2.")]), _vm._v(" David D. Porter, “The Opening of the Lower Mississippi,” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Battles and Leaders of the Civil War")]), _vm._v(" (New York, 1887), 2:22. Hereafter Cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("B&L")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a3",
      "id": "n3"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Official Records of the Union and Confederate Navies in the War of the Rebellion")]), _vm._v(", 31 vols. (Washington, D.C.: Government Printing Office, 1880-1901), vol. 4, ser. 1, 156-157. All references are to Series 1 unless otherwise noted. Hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(" 4:156-157.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a4",
      "id": "n4"
    }
  }, [_vm._v("4.")]), _vm._v("  Raphael Semmes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of Service Afloat: During the War Between the States")]), _vm._v(" (Baltimore, MD, 1868), 93-94.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a5",
      "id": "n5"
    }
  }, [_vm._v("5.")]), _vm._v("  “Arrived Yesterday,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", Mar. 19, 1861; Ibid; “Navy of the Confederacy,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dallas")]), _vm._v(" [TX] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Herald")]), _vm._v(", May 22, 1861; “The Steamers Star of the West and Habana,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore")]), _vm._v(" [MD] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Exchange")]), _vm._v(", Apr. 24, 1861; Captain Laurence Rousseau, “Purchase Order for Habana and Marquis de la Habana,” Apr. 20, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File for the Confederate States Navy, 1861-1865")]), _vm._v(". (National Archives Microfilm Publication M1091, Records Group 45, National Archives Building, Washington D.C.), Subject File AC: Construction. Hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AC, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a6",
      "id": "n6"
    }
  }, [_vm._v("6.")]), _vm._v(" James M. Morgan, “The Pioneer Ironclad,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("United States Naval Institute Proceedings")]), _vm._v(" (1917), No. 10. 43:2277; Neil P Chatelain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fought Like Devils: The Confederate Gunboat McRae")]), _vm._v(" (Bloomington, IN, 2014), 2-7; “Talk on Change,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", Jun. 28, 1861.; Captain Lawrence Rousseau, “Purchase Order for Habana and Marquis de la Habana, Apr. 20, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AC, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a7",
      "id": "n7"
    }
  }, [_vm._v("7.")]), _vm._v(" United States Naval War Records Office. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Register of Officers of the Confederate States Navy 1861-1865")]), _vm._v(" (Washington D.C., 1931), 33, 56, 106, 189. Hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confederate Navy Register")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a8",
      "id": "n8"
    }
  }, [_vm._v("8.")]), _vm._v(" “Bombardment of Fort Sumter,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Keowee")]), _vm._v(" [SC] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Courior")]), _vm._v(", May 18, 1861; Chatelain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fought Like Devils")]), _vm._v(", 10-11; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confederate Navy Register")]), _vm._v(", 53, 54, 204.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a9",
      "id": "n9"
    }
  }, [_vm._v("9.")]), _vm._v(" “Report of Secretary Mallory” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(", ser. 2, 2: 52; “Message from Jefferson Davis,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shreveport")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily News")]), _vm._v(", May 11, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a10",
      "id": "n10"
    }
  }, [_vm._v("10.")]), _vm._v("  John Adams Dix, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of John Adams Dix")]), _vm._v(", (New York, 1883), 1:376; “Our Little Navy,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Shreveport")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weekly News")]), _vm._v(", Jun. 3, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a11",
      "id": "n11"
    }
  }, [_vm._v("11.")]), _vm._v(" “The Confederate Navy,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", May 27, 1861; Confederate States of America War Department, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Proceedings of the Court of Inquiry Relative to the Fall of New Orleans")]), _vm._v(" (Richmond, VA, 1864), 123 (hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Court of Inquiry")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a12",
      "id": "n12"
    }
  }, [_vm._v("12.")]), _vm._v(" “Departure of Marines,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(" (New Orleans, LA), Apr. 24, 1861; Stephen Mallory to A.C. Van Benthuysen, Mar. 30, 1861, A.C. Van Benthuysen Papers, Louisiana Historical Association Collection, Tulane University.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a13",
      "id": "n13"
    }
  }, [_vm._v("13.")]), _vm._v(" Ralph W. Donnelly, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Confederate States Marine Corps: The Rebel Leathernecks")]), _vm._v(" (Shippensburg, PA, 1989), 16-17; Stephen Mallory to A.C. Van Benthuysen,” Apr. 29, 1861, A.C. Van Benthuysen Papers; Michael E. Krivdo, “Confederate Marine Corps Recruiting in New Orleans and Marine Activities in the First Year of the Civil War,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Louisiana History")]), _vm._v(" (Fall 2007), No. 4, 40:464; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confederate")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("States of America, Journal of the Congress of the Confederate States of America")]), _vm._v(" (Washington D.C., 1904-1905) 5:184 (hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Confederate Congress Journal")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a14",
      "id": "n14"
    }
  }, [_vm._v("14.")]), _vm._v("  “The Yankee Note-Book Continued,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Galveston")]), _vm._v(" [TX] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tri-Weekly News")]), _vm._v(", Oct. 1, 1863; Henry O. Gusley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Southern Journey of a Civil War Marine: The Illustrated Note-Book of Henry O. Gusley")]), _vm._v(" (Austin, TX, 2006) 45.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a15",
      "id": "n15"
    }
  }, [_vm._v("15.")]), _vm._v(" “Payment Receipt for CSS Florida,” Sept. 29, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AC, NA; “Payment Receipt for CSS Florida,” Aug. 30, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", BG, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a16",
      "id": "n16"
    }
  }, [_vm._v("16.")]), _vm._v(" John Kell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recollections of a Naval Life")]), _vm._v(" (Washington, 1900), 146; Semmes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of Service Afloat")]), _vm._v(", 102-103; “Fatal Fall,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily True Delta")]), _vm._v(" (New Orleans, LA), Jun. 21, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a17",
      "id": "n17"
    }
  }, [_vm._v("17.")]), _vm._v("  Semmes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of Service Afloat")]), _vm._v(", 96, 98; “Payment Receipt for CSS Sumter,” Jun. 13, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AS, NA; Kell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recollections of a Naval Life")]), _vm._v(", 146; John Roy, Diary, May 16, 1861, Louisiana Historical Association Collection, Howard-Tilton Memorial Library, Tulane University.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a18",
      "id": "n18"
    }
  }, [_vm._v("18.")]), _vm._v("  Semmes, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Memoirs of Service Afloat")]), _vm._v(", 99; John Roy, Diary, May 28 and 31, 1861; “Payment Receipt for CSS Sumter,” Jun. 15, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", BA, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a19",
      "id": "n19"
    }
  }, [_vm._v("19.")]), _vm._v(" John H. Dent, Jr. to John H. Dent, Jun. 25, 1861, John Horry Dent, Jr., Letters, University Libraries Division of Special Collections, The University of Alabama; “Payment Estimate for CSS McRae,” May 16, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AD, NA; “Payment Receipt for CSS McRae,” Jul. 25, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", BG, NA; “Payment Receipt for CSS McRae,” Jun. 17, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", EB, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a20",
      "id": "n20"
    }
  }, [_vm._v("20.")]), _vm._v(" “The Confederate Navy,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", May 27, 1861; Kell, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Recollections of a Naval Life")]), _vm._v(", 146.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a21",
      "id": "n21"
    }
  }, [_vm._v("21.")]), _vm._v(" “Report of Major General Pillow,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(" 20:789; “The Latest News by Telegraph,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hartford")]), _vm._v(" [CT] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Courant")]), _vm._v(", Jun. 20, 1861; John H. Dent, Jr. to John H. Dent, Jun. 25, 1861, John Horry Dent, Jr. Letters.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a22",
      "id": "n22"
    }
  }, [_vm._v("22.")]), _vm._v("  John H. Dent, Jr. to John H. Dent, 6 Jul. 1861, Ibid; John Roy, Diary, Jun. 18, 1861. ")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a23",
      "id": "n23"
    }
  }, [_vm._v("23.")]), _vm._v("  “Letter from Commander Raphael Semmes,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(" 1: 615.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a24",
      "id": "n24"
    }
  }, [_vm._v("24.")]), _vm._v("  John H. Dent, Jr. to John H. Dent, 21 Jul. 1861, John Horry Dent, Jr., Letters.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a25",
      "id": "n25"
    }
  }, [_vm._v("25.")]), _vm._v(" John H. Dent, Jr. to John H. Dent, Jul. 21, 1861 and August 3, 1861, John Horry Dent, Jr., Letters; “Letter from Secretary Mallory,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(", Ser. 2, 2: 81-82; “Sail Contract for CSS McRae,” May 1, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", AD, NA; “Payment Receipt for CSS McRae,” Jun. 28, 1861, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", EM, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a26",
      "id": "n26"
    }
  }, [_vm._v("26.")]), _vm._v(" John H. Dent, Jr. to John H. Dent, Aug. 10, 1861, John Horry Dent, Jr., Letters; John Roy, Diary, May 29, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a27",
      "id": "n27"
    }
  }, [_vm._v("27.")]), _vm._v("  Stephen R. Mallory Diary, Jul. 25, 1861, vol. 1, Southern Historical Collection, The Wilson Library, University of North Carolina at Chapel Hill; “The Declaration of Paris, 1856,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The American Journal of International Law")]), _vm._v(" (1907), No. 2. Supplement: Official Documents, 1:89-90.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a28",
      "id": "n28"
    }
  }, [_vm._v("28.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ship Register and Enrollments of New Orleans, Louisiana")]), _vm._v(" (Baton Rouge, Louisiana, 1942). 6:42. Hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans Ship Register")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a29",
      "id": "n29"
    }
  }, [_vm._v("29.")]), _vm._v(" “Arrival of Prizes,” The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carrolton")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sun")]), _vm._v(", May 29, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a30",
      "id": "n30"
    }
  }, [_vm._v("30.")]), _vm._v(" “Sale of the Privateers’ Prizes,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", Jul. 29, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a31",
      "id": "n31"
    }
  }, [_vm._v("31.")]), _vm._v(" William M. Robinson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Confederate Privateers")]), _vm._v(" (New Haven, CT, 1928), 40-41; “What Shall Be Done With Them?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Daily Crescent")]), _vm._v(", May 30, 1861.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a32",
      "id": "n32"
    }
  }, [_vm._v("32.")]), _vm._v(" Robinson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Confederate Privateers")]), _vm._v(", 42.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a33",
      "id": "n33"
    }
  }, [_vm._v("33.")]), _vm._v(" “New Orleans,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harper’s Weekly")]), _vm._v(", May 10, 1862.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a34",
      "id": "n34"
    }
  }, [_vm._v("34.")]), _vm._v(" Codman Parkerson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Orleans: America’s Most Fortified City")]), _vm._v(" (New Orleans, LA, 1990), 60-105, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("passim")]), _vm._v("; U.S. Ship Portsmouth Log, May 9, 1862, Williams Research Center, The Historic New Orleans Collection.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a35",
      "id": "n35"
    }
  }, [_vm._v("35.")]), _vm._v("  Stephen R. Mallory Diary, Sept. 14, 1861, Vol. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a36",
      "id": "n36"
    }
  }, [_vm._v("36.")]), _vm._v(" Alfred Thayer Mahan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gulf and Inland Waters")]), _vm._v(" (New York, 1883), 70-71; John Roy, Diary, May 1, 1861; “Anonymous Letter,” Jul. 3, 1861, Anonymous Confederate Letter, Louisiana and Lower Mississippi Valley Collections, Louisiana State University Libraries, Baton Rouge, LA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a37",
      "id": "n37"
    }
  }, [_vm._v("37.")]), _vm._v(" Neil P. Chatelain, “William S. Lovell: Confederate Army Riverine Expert,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Civil War Navy–The Magazine")]), _vm._v(" (Winter 2019), No. 3, 6:17-18.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a38",
      "id": "n38"
    }
  }, [_vm._v("38.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Court of Inquiry")]), _vm._v(", 67; Read, “Reminiscences of the Confederate Navy,” 341.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a39",
      "id": "n39"
    }
  }, [_vm._v("39.")]), _vm._v(" Jefferson Davis, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Rise and Fall of the Confederate Government")]), _vm._v(", (New York, 1881), 2:213.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a40",
      "id": "n40"
    }
  }, [_vm._v("40.")]), _vm._v("  “Alexander F. Warley Papers,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", HJ, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a41",
      "id": "n41"
    }
  }, [_vm._v("41.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a42",
      "id": "n42"
    }
  }, [_vm._v("42.")]), _vm._v(" Chatelain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fought Like Devils")]), _vm._v(", 20-22.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a43",
      "id": "n43"
    }
  }, [_vm._v("43.")]), _vm._v(" “The Engagement at Ship Island,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore")]), _vm._v(" [MD] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sun")]), _vm._v(", Jul. 26, 1861; “Alexander F. Warley Papers,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", HJ, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a44",
      "id": "n44"
    }
  }, [_vm._v("44.")]), _vm._v(" “Report of Commander Smith,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(" 16:581; “The Engagement at Ship Island,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Baltimore")]), _vm._v(" [MD] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sun")]), _vm._v(", Jul. 26, 1861; “A Naval Brush at Ship Island,” The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shreveport")]), _vm._v(" [LA] "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weekly News")]), _vm._v(", Jul. 22, 1861; Read, “Reminiscences of the Confederate States Navy,” 333.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a45",
      "id": "n45"
    }
  }, [_vm._v("45.")]), _vm._v(" “Report of Lieutenant Warley,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The War of the Rebellion: A Compilation of the Official Records of the Union and Confederate Armies")]), _vm._v(", 128 Vols. (Washington, DC, 1880-1901), Ser. 1, 53:709. All reference are to Series 1 unless otherwise noted. Hereafter cited as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 53:709; “Alexander F. Warley Papers,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Subject File")]), _vm._v(", HJ, NA.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a46",
      "id": "n46"
    }
  }, [_vm._v("46.")]), _vm._v(" “Report of Commander Smith,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(", Ser. 1, Vol. 16, 602.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a47",
      "id": "n47"
    }
  }, [_vm._v("47.")]), _vm._v(" “Letter of Major General David Twiggs to Leroy P. Walker,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 53:720.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a48",
      "id": "n48"
    }
  }, [_vm._v("48.")]), _vm._v(" “Letter of Colonel Johnson Duncan,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 6:733; “Letter of Major Martin L. Smith,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 6:736.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a49",
      "id": "n49"
    }
  }, [_vm._v("49.")]), _vm._v(" “Report of Colonel Johnson Duncan,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 53:740; “Note from General Samuel Cooper,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("OR")]), _vm._v(", 6:738.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/010_Chapter_1#a50",
      "id": "n50"
    }
  }, [_vm._v("50.")]), _vm._v(" “Report of Commander Smith,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(", 16: 678; “Note from Lieutenant Colonel Henry W. Allen to Commander Smith,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ORN")]), _vm._v(", 16:679.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ffd841","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/010_Chapter_1.vue
// module id = 87
// module chunks = 0